ixModuleRouting("impactx.stockwithdrawal", {
    "/stockwithdrawallistopen": {
        template: "<ixa-stock-withdrawal-list-open></ixa-stock-withdrawal-list-open>",
        templateUrl:
            "modules/stockwithdrawal/templates/stock-withdrawal-list-open.html",
        controller: "StockWithdrawalOpenListCtrl",
        controllerAs: "stockWithdrawalOpenListCtrl",
        process: "ListStockWithdrawalOpen",
        workspace: "shop",
    },
    "/stockwithdrawallistexpensed": {
        template: "<ixa-stock-withdrawal-list-expensed></ixa-stock-withdrawal-list-expensed>",
        templateUrl:
            "modules/stockwithdrawal/templates/stock-withdrawal-list-expensed.html",
        controller: "StockWithdrawalExpensedListCtrl",
        controllerAs: "stockWithdrawalExpensedListCtrl",
        process: "ListStockWithdrawalOpen",
        workspace: "shop",
    },
    "/stockwithdrawal/:dniInfoId?/:stoliId?": {
        template: "<ixa-stock-withdrawal-detail></ixa-stock-withdrawal-detail>",
        templateUrl: "modules/stockwithdrawal/templates/stock-withdrawal.html",
        controller: "StockWithdrawalCtrl",
        controllerAs: "stockWithdrawalCtrl",
        process: "ViewStockWithdrawal",
        workspace: "shop",
    },
});
